import { useMemo } from "react"
import useSWR from "swr"
import { useGeneral } from '../../../context/general'
import axios from "axios"

export function useGeneralData(){
    const {data: users} = useSWR('/api/getAllUsers')
    const { setPopupAlert, allDatasetsOptions: datasets } = useGeneral()

    const usersOptions = useMemo(() => users?.map(user => ({"name": `${user['first_name']} ${user['last_name']}`, "value": user['uuid']})), [users])    
    const datasetsOptions = useMemo(() => datasets?.data.map(dataset => ({"name": dataset['name'], "value": dataset['value']})), [datasets])    

    const blockDatasets = (datasets, users) => {
        for (let user of users){
            // fetch('/api/blockUserFromDataset', {
            //     method: 'POST',
            //     headers: { 'Content-Type': 'application/json' },
            //     body: JSON.stringify({
            //         datasets: datasets.map(data => data.value),
            //         userUuid: user.value,
            //     })
            // })
            axios({
                method:"POST",
                url:'/api/blockUserFromDataset',
                data:{
                    datasets: datasets.map(data => data.value),
                    userUuid: user.value,
                }
            }).then(res => {
                res.status === 200 
                ? setPopupAlert('success', 'Users are blocked from the selected datasets')
                : setPopupAlert('error', 'Something went wrong, datasets werent blocked')
            })
        }
    }
    const AccessDatasets = (datasets, users)=>{
        for (let user of users){
            // fetch('/api/AccessUsertoDataset', {
            //     method: 'POST',
            //     headers: { 'Content-Type': 'application/json' },
            //     body: JSON.stringify({
            //         datasets: datasets.map(data => data.value),
            //         userUuid: user.value,
            //     })
            // })
            axios({
                method:"POST",
                url:'/api/AccessUsertoDataset',
                data:{
                    datasets: datasets.map(data => data.value),
                    userUuid: user.value,
                }
            }).then(res => {
                res.status === 200 
                ? setPopupAlert('success', 'Grant access to Users from the selected datasets')
                : setPopupAlert('error', 'Something went wrong, datasets access is not granted to Users')
            })
        }

    }

    const updateRanking = (dataset, column, industry, subIndustry, newRank) => {
        // fetch('/api/updateRank', {
        //     method: 'POST',
        //     headers: { 'Content-Type': 'application/json' },
        //     body: JSON.stringify({dataset, column, industry, subIndustry, newRank})
        // })
        axios({
            method:"POST",
            url:'/api/updateRank',
            data:{dataset, column, industry, subIndustry, newRank}
        }).then(res => {
            res.status === 200 
            ? setPopupAlert('success', `Ranking for ${subIndustry} updated`)
            : setPopupAlert('error', 'Something went wrong, ranking wasnt updated')
        })
    }

    return {
        users: usersOptions || [],
        datasets: datasetsOptions || [],
        blockDatasets,
        AccessDatasets,
        datasetsInfo: datasets?.data,
        updateRanking
    }
}